import { Box, Link, Stack, Typography } from '@mui/material';

const APP_STORE_URL = 'https://apps.apple.com/us/app/beauty-pass-ltd/id1169483314';
const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=net.beautypass.beautypass';

/**
 * Full-screen prompt shown to authenticated users on small viewports. The
 * venue admin dashboard is desktop-only, so on mobile we redirect users to the
 * native apps instead of rendering the (unusable) dashboard.
 */
const MobileDownloadGate = () => (
  <Box
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: 1400,
      backgroundColor: '#ffffff',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      px: 3,
      py: 6,
    }}
  >
    <Stack spacing={1.5} alignItems='center' sx={{ maxWidth: 360 }}>
      <Box
        component='img'
        src='/logo-header.png'
        alt='Beautypass'
        sx={{ height: 40, width: 'auto', mb: 1 }}
      />

      <Typography sx={{ fontSize: '1.35rem', fontWeight: 700, color: '#141824' }}>
        Use Beautypass on the app
      </Typography>

      <Typography sx={{ fontSize: '1rem', color: '#5b5f6b', lineHeight: 1.5 }}>
        The dashboard is built for desktop. To use Beautypass on your phone,
        download the app.
      </Typography>

      <Stack direction='row' spacing={1.5} justifyContent='center' sx={{ mt: 2 }}>
        <Link href={APP_STORE_URL} target='_blank' rel='noopener noreferrer'>
          <Box
            component='img'
            src='/badge-app-store.png'
            alt='Download on the App Store'
            sx={{ height: 48, width: 'auto', display: 'block' }}
          />
        </Link>
        <Link href={PLAY_STORE_URL} target='_blank' rel='noopener noreferrer'>
          <Box
            component='img'
            src='/badge-google-play.png'
            alt='Get it on Google Play'
            sx={{ height: 48, width: 'auto', display: 'block' }}
          />
        </Link>
      </Stack>
    </Stack>
  </Box>
);

export default MobileDownloadGate;
